import { useState } from 'react';

export default function MiracorePoints() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-amber-50/30 to-pink-50/30">
      {/* ヘッダー */}
      <header className="bg-white/90 backdrop-blur-sm border-b border-amber-200/50 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="flex items-center justify-center">
            <div className="flex items-center gap-3">
              <img src="https://dynavision.co.jp/MiracleCollection/img/logo.png" alt="ミラクルコレクション" className="h-12" />
            </div>
          </div>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="max-w-6xl mx-auto px-6 py-16">
        {/* タイトルセクション */}
        <section className="text-center mb-20">
          <div className="mb-8">
            <img src="https://dynavision.co.jp/MiracleCollection/img/logo.png" alt="ミラクルコレクション" className="h-16 mx-auto mb-6 animate-pulse" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-8 text-amber-800" style={{ fontFamily: "'Noto Serif JP', serif", letterSpacing: '0.1em' }}>
            ミラコレポイント制度
          </h1>
          <div className="inline-block bg-gradient-to-r from-amber-100 via-pink-100 to-amber-100 px-8 py-3 rounded-full border-2 border-amber-300 mb-8">
            <p className="text-amber-900 font-bold text-lg">継続1周年の感謝を込めて</p>
          </div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed mb-6">
            ミラクルコレクション継続1周年の方に贈られる特別感謝ポイント。<br />
            自動更新をご継続いただいたメンバーへ毎年<strong className="text-amber-700 text-2xl">30,000ポイント</strong>を還元する制度です。
          </p>
          <div className="inline-flex items-center gap-3 bg-white border-2 border-amber-400 px-8 py-4 rounded-2xl shadow-lg">
            <i className="ri-money-yen-circle-fill text-amber-600 text-3xl"></i>
            <span className="text-amber-900 font-bold text-xl">1ポイント = 1円相当の価値</span>
          </div>
        </section>

        {/* ミラコレポイントとは */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-amber-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">1</span>
              </div>
              <h2 className="text-3xl font-bold text-amber-900">ミラコレポイントとは？</h2>
            </div>

            <div className="space-y-6">
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-6 border border-amber-200">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                      <i className="ri-gift-2-fill text-amber-600 text-3xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-amber-900 mb-2">名称</h3>
                    <p className="text-gray-700 font-medium">ミラコレポイント</p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-6 border border-pink-200">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                      <i className="ri-user-heart-fill text-pink-600 text-3xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-pink-900 mb-2">対象</h3>
                    <p className="text-gray-700 font-medium">1年以上継続<br />（自動更新）の会員</p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 border border-amber-200">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                      <i className="ri-calendar-check-fill text-amber-600 text-3xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-amber-900 mb-2">初年度のみ</h3>
                    <p className="text-gray-700 font-medium">2025年12月<br />一括付与</p>
                    <p className="text-gray-600 text-sm mt-3">（12月1日までに1年経過している方のみ）</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 基本ルール */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-amber-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">2</span>
              </div>
              <h2 className="text-3xl font-bold text-amber-900">ミラコレポイントの基本ルール</h2>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-8 border-l-4 border-amber-500">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center">
                      <i className="ri-alert-fill text-white text-xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="font-bold text-amber-900 mb-3 text-xl">● 付与されたポイントは"そのまま"では使えない</h3>
                    <p className="text-gray-700 text-lg leading-relaxed">
                      → 使う前に <strong className="text-amber-700 text-xl">用途別ポイントへ移行</strong> が必要。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl p-8 border-l-4 border-rose-500">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-rose-500 rounded-full flex items-center justify-center">
                      <i className="ri-time-fill text-white text-xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="font-bold text-rose-900 mb-3 text-xl">● 移行期限</h3>
                    <p className="text-gray-700 text-lg leading-relaxed mb-2">
                      付与日から<strong className="text-rose-700 text-xl">6ヶ月以内</strong>に移行が必要
                    </p>
                    <p className="text-rose-700 font-bold text-lg">
                      移行しない場合 → ミラコレポイントは失効します。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 移行先は2種類 */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-amber-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">3</span>
              </div>
              <h2 className="text-3xl font-bold text-amber-900">移行先は2種類</h2>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {/* セミナーポイント */}
              <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-3xl p-8 border-2 border-amber-300 shadow-lg">
                <div className="text-center mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg mb-4">
                    <i className="ri-presentation-line text-amber-600 text-4xl"></i>
                  </div>
                  <div className="inline-block bg-amber-600 text-white px-4 py-1 rounded-full text-sm font-bold mb-3">
                    ①
                  </div>
                  <h3 className="text-2xl font-bold text-amber-900 mb-2">セミナーポイント</h3>
                </div>

                <div className="space-y-4">
                  <div className="bg-white rounded-xl p-5 shadow-sm">
                    <h4 className="font-bold text-amber-900 mb-3 flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-amber-600"></i>
                      利用可能サービス
                    </h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-amber-500 mt-1"></i>
                        <span>ダイナビジョン主催セミナー</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-amber-500 mt-1"></i>
                        <span>ワークショップ</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-amber-500 mt-1"></i>
                        <span>オンライン講座</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-amber-500 mt-1"></i>
                        <span>リアルイベント</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-amber-500 mt-1"></i>
                        <div>
                          <span>その他、</span>
                          <a 
                            href="https://dynavision.shop/shop/shopbrand.html" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-amber-600 hover:text-amber-700 underline font-medium whitespace-nowrap cursor-pointer"
                          >
                            こちらへ掲載のイベント
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white rounded-xl p-5 shadow-sm">
                    <h4 className="font-bold text-amber-900 mb-2">【レート】</h4>
                    <p className="text-amber-700 font-bold text-lg">1ミラコレポイント ＝ 1セミナーポイント<br />（1円相当）</p>
                  </div>

                  <div className="bg-white rounded-xl p-5 shadow-sm">
                    <h4 className="font-bold text-amber-900 mb-2">【有効期限】</h4>
                    <p className="text-gray-700 font-medium">移行日から<strong className="text-amber-700">2年間</strong></p>
                  </div>
                </div>
              </div>

              {/* レインボーポイント */}
              <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8 border-2 border-pink-300 shadow-lg">
                <div className="text-center mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg mb-4">
                    <i className="ri-shopping-bag-3-line text-pink-600 text-4xl"></i>
                  </div>
                  <div className="inline-block bg-pink-600 text-white px-4 py-1 rounded-full text-sm font-bold mb-3">
                    ②
                  </div>
                  <h3 className="text-2xl font-bold text-pink-900 mb-2">レインボーポイント</h3>
                </div>

                <div className="space-y-4">
                  <div className="bg-white rounded-xl p-5 shadow-sm">
                    <h4 className="font-bold text-pink-900 mb-3 flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-pink-600"></i>
                      利用可能サービス
                    </h4>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-pink-500 mt-1"></i>
                        <span>レインボーエンジェルズ WEBショップ</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-pink-500 mt-1"></i>
                        <div>
                          <a 
                            href="https://www.rainbowangels.jp/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-pink-600 hover:text-pink-700 underline font-medium cursor-pointer"
                          >
                            こちらへ掲載の商品
                          </a>
                          <span>がポイント利用可能</span>
                        </div>
                      </li>
                    </ul>
                    <div className="mt-4 pt-4 border-t border-pink-200">
                      <p className="text-gray-600 text-sm flex items-center gap-2">
                        <i className="ri-close-circle-fill text-pink-500"></i>
                        <span>店舗利用不可</span>
                      </p>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl p-5 shadow-sm">
                    <h4 className="font-bold text-pink-900 mb-2">【レート】</h4>
                    <p className="text-pink-700 font-bold text-lg">1ミラコレポイント ＝ 1レインボーポイント<br />（1円相当）</p>
                  </div>

                  <div className="bg-white rounded-xl p-5 shadow-sm">
                    <h4 className="font-bold text-pink-900 mb-2">【有効期限】</h4>
                    <p className="text-gray-700 font-medium">移行日から<strong className="text-pink-700">2年間</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* フローチャート */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-amber-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">4</span>
              </div>
              <h2 className="text-3xl font-bold text-amber-900">ポイント移行の流れ</h2>
            </div>

            <div className="max-w-2xl mx-auto">
              <div className="border-2 border-amber-300 rounded-2xl p-8 bg-gradient-to-br from-amber-50 to-yellow-50">
                {/* ステップ1 */}
                <div className="text-center mb-6">
                  <div className="inline-block bg-white rounded-2xl px-8 py-6 shadow-lg border-2 border-amber-300">
                    <h3 className="text-xl font-bold text-amber-900 mb-2">1. ミラコレポイント付与（30,000pt）</h3>
                  </div>
                </div>

                {/* 矢印 */}
                <div className="text-center mb-6">
                  <i className="ri-arrow-down-line text-5xl text-amber-500"></i>
                  <p className="text-amber-700 font-bold mt-2">（6ヶ月以内に選択）</p>
                </div>

                {/* ステップ2 */}
                <div className="text-center mb-6">
                  <div className="inline-block bg-white rounded-2xl px-8 py-6 shadow-lg border-2 border-amber-300">
                    <h3 className="text-xl font-bold text-amber-900">用途に応じてポイントを移行する</h3>
                  </div>
                </div>

                {/* 矢印 */}
                <div className="text-center mb-6">
                  <i className="ri-arrow-down-line text-5xl text-amber-500"></i>
                </div>

                {/* 分岐 */}
                <div className="grid md:grid-cols-2 gap-4 mb-6">
                  <div className="bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl p-6 text-white text-center shadow-lg">
                    <i className="ri-presentation-line text-4xl mb-2"></i>
                    <h4 className="font-bold text-lg mb-1">セミナーポイントへ移行</h4>
                    <p className="text-sm text-amber-100">（セミナー・WS・講座等）</p>
                  </div>

                  <div className="bg-gradient-to-br from-pink-400 to-pink-600 rounded-2xl p-6 text-white text-center shadow-lg">
                    <i className="ri-shopping-bag-3-line text-4xl mb-2"></i>
                    <h4 className="font-bold text-lg mb-1">レインボーポイントへ移行</h4>
                    <p className="text-sm text-pink-100">（WEBショップ利用）</p>
                  </div>
                </div>

                {/* 矢印 */}
                <div className="text-center mb-6">
                  <p className="text-amber-700 font-bold mb-2">（どちらも）</p>
                  <i className="ri-arrow-down-line text-5xl text-amber-500"></i>
                </div>

                {/* 最終 */}
                <div className="text-center">
                  <div className="inline-block bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl px-8 py-6 text-white shadow-lg">
                    <h3 className="text-xl font-bold">【移行後：2年間利用可能】</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ポイント期限まとめ */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-amber-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">5</span>
              </div>
              <h2 className="text-3xl font-bold text-amber-900">ポイント期限まとめ</h2>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full border-2 border-amber-200 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-gradient-to-r from-amber-400 to-amber-600 text-white">
                    <th className="px-8 py-5 text-left font-bold text-lg border-r border-amber-300">ポイント種別</th>
                    <th className="px-8 py-5 text-left font-bold text-lg">利用期限</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b-2 border-amber-200 bg-amber-50/50">
                    <td className="px-8 py-5 font-bold text-gray-800 border-r border-amber-200">ミラコレポイント</td>
                    <td className="px-8 py-5 text-rose-700 font-bold">6ヶ月以内に移行が必要</td>
                  </tr>
                  <tr className="border-b-2 border-amber-200 bg-white">
                    <td className="px-8 py-5 font-bold text-gray-800 border-r border-amber-200">セミナーポイント</td>
                    <td className="px-8 py-5 text-gray-700">移行後2年間</td>
                  </tr>
                  <tr className="bg-amber-50/50">
                    <td className="px-8 py-5 font-bold text-gray-800 border-r border-amber-200">レインボーポイント</td>
                    <td className="px-8 py-5 text-gray-700">移行後2年間</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="mb-20">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-amber-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">6</span>
              </div>
              <h2 className="text-3xl font-bold text-amber-900">よくある質問(FAQ)</h2>
            </div>

            <div className="space-y-6">
              <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-6 border-l-4 border-amber-500">
                <h3 className="font-bold text-amber-900 mb-3 text-lg">
                  <span className="inline-block bg-amber-500 text-white w-8 h-8 rounded-full text-center leading-8 mr-2">Q1</span>
                  ミラコレポイントはそのままでは使えますか？
                </h3>
                <p className="text-gray-700 ml-10">
                  <strong className="text-amber-700">→ 使えません。</strong>必ず移行が必要です。
                </p>
              </div>

              <div className="bg-gradient-to-r from-pink-50 to-rose-50 rounded-2xl p-6 border-l-4 border-pink-500">
                <h3 className="font-bold text-pink-900 mb-3 text-lg">
                  <span className="inline-block bg-pink-500 text-white w-8 h-8 rounded-full text-center leading-8 mr-2">Q2</span>
                  移行後のポイントは戻せますか？
                </h3>
                <p className="text-gray-700 ml-10">
                  <strong className="text-pink-700">→ 不可。</strong>セミナー⇄レインボーへの変更はできません。
                </p>
              </div>

              <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-6 border-l-4 border-orange-500">
                <h3 className="font-bold text-orange-900 mb-3 text-lg">
                  <span className="inline-block bg-orange-500 text-white w-8 h-8 rounded-full text-center leading-8 mr-2">Q3</span>
                  退会した場合はどうなりますか？
                </h3>
                <p className="text-gray-700 ml-10">
                  <strong className="text-orange-700">→ ミラコレポイントも、移行後ポイントも</strong>すべて無効となります。
                </p>
              </div>

              <div className="bg-gradient-to-r from-rose-50 to-red-50 rounded-2xl p-6 border-l-4 border-rose-500">
                <h3 className="font-bold text-rose-900 mb-3 text-lg">
                  <span className="inline-block bg-rose-500 text-white w-8 h-8 rounded-full text-center leading-8 mr-2">Q4</span>
                  移行期限を過ぎた場合は？
                </h3>
                <p className="text-gray-700 ml-10">
                  <strong className="text-rose-700">→ ミラコレポイントは自動失効</strong>します。
                </p>
              </div>

              <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-2xl p-6 border-l-4 border-purple-500">
                <h3 className="font-bold text-purple-900 mb-3 text-lg">
                  <span className="inline-block bg-purple-500 text-white w-8 h-8 rounded-full text-center leading-8 mr-2">Q5</span>
                  移行申請後のキャンセルや、移行後の変更はできますか？
                </h3>
                <p className="text-gray-700 ml-10">
                  <strong className="text-purple-700">→ できません。</strong>移行申請後のキャンセル、移行後の変更はできません。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* フッター */}
      <footer className="bg-gradient-to-r from-amber-100 via-pink-100 to-amber-100 py-12 border-t-2 border-amber-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <div className="mb-6">
              <img src="https://dynavision.co.jp/MiracleCollection/img/logo.png" alt="ミラクルコレクション" className="h-12 mx-auto mb-4" />
            </div>
            <p className="text-amber-900 mb-6 font-medium">継続いただいているメンバーの皆様に感謝を込めて</p>
            <div className="border-t border-amber-300 pt-6">
              <p className="text-amber-800 text-sm">Copyright © Dynavision Co.,Ltd. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
